import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import { dispatch } from "../../state/store";
import { setNotificationCampaignDetailsRefresh } from "../../state/ducks";

import { strCode } from "../../consts";
import { log, notificationCampaignsService, notificationService, t } from "../../services";

export const useFetchNotificationCampaignDetails = () => {
  const data = useSelector((store) => store.notificationCampaigns.notificationCampaignDetails);
  const refresh = useSelector(
    (store) => store.notificationCampaigns.notificationCampaignDetailsRefresh
  );

  const [isLoading, setIsLoading] = useState(false);

  const fetchCallback = useCallback(
    async (campaignName, isRefresh) => {
      if ((data !== null && !isRefresh) || isLoading) {
        return;
      }

      setIsLoading(true);

      try {
        await notificationCampaignsService.fetchCampaignDetails(campaignName);
      } catch (err) {
        if (err?.response?.data?.error !== "CAMPAIGN_IS_NOT_FOUND") {
          log.error(
            "useFetchNotificationCampaignDetails: Failed to fetch notification campaign details",
            err
          );

          notificationService.showError({
            title: t(strCode.FETCH_NOTIFICATION_CAMPAIGNS_ERROR),
            message: err?.response?.data?.error ? t(err.response.data.error) : err?.toString()
          });
        }
      } finally {
        setIsLoading(false);
        dispatch(setNotificationCampaignDetailsRefresh(false));
      }
    },
    [data, refresh]
  );

  return { fetchCallback, data, refresh, isLoading };
};
